export const ROW_HEIGHT = 45

export const MIN_ROWS = 4
export const MAX_ROWS = 6

export const WIDTHS = {
  width33Percent: 4,
  width50Percent: 6,
  width66Percent: 8,
  width100Percent: 12
}

export const SETTING_PLACEHOLDERS = {
  toolbar: 'toolbar',
  settings: 'settings',
  footer: 'footer'
}

export const SELECTOR_COMPONENTS = {
  radioSelector: 'ed-radio',
  checkBoxSelector: 'ed-checkbox',
  dropDownSelector: 'ed-select',
  currencySelector: 'ed-select'
}

export function getWidgetSize(renderComponent) {
  const result = { MIN_ROWS: 8, MAX_ROWS: 8, NA_ROWS: 5, EX_MAX_ROWS: 20 }
  switch (renderComponent) {
    case 'shortcuts-wdg-cmp':
      result.MIN_ROWS = 2
      result.MAX_ROWS = 3
      result.NA_ROWS = 2
      break
    case 'news-wdg-cmp':
      result.MIN_ROWS = 2
      result.MAX_ROWS = 5
      break
    case 'approval-needed-wdg-cmp':
    case 'recent-updates-wdg-cmp':
      result.MIN_ROWS = 2
      result.MAX_ROWS = 10
      break
    case 'paymentSupplierType-wdg-cmp' :
      result.MIN_ROWS = 4
      result.MAX_ROWS = 4
      break
    case 'hotelSpend-wdg-cmp' :
      result.MIN_ROWS = 6
      result.MAX_ROWS = 6
      result.NA_ROWS = 5
      break
    case 'current-invoices-wdg-cmp' :
    case 'current-programs-wdg-cmp' :
      result.MIN_ROWS = 2
      result.MAX_ROWS = 4
      result.NA_ROWS = 2
      break
    case 'immediate-payment-escrows-wdg-cmp':
      result.MIN_ROWS = 2
      result.MAX_ROWS = 10
      result.NA_ROWS = 2
      break
  }
  return result
}



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/SharedComponents/constants.js